import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { LiksErrorBoundary } from './components/liks/LiksErrorBoundary/LiksErrorBoundary';
import { ChatSessionsProvider } from './features/chat/chatSessions/ChatSessionsProvider';
import { ChatMessagesProvider } from './features/chat/chatMessages/ChatMessagesProvider';
import { LiveEventsProvider } from './features/liveEvents/LiveEventsProvider';
import { I18nProvider } from './i18n/I18nProvider';
import { UserConfigProvider } from './userConfig/UserConfigProvider';
import { ToastProvider } from './toast/ToastProvider';
import { QueryProvider } from './query/QueryProvider';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return (
    <BrowserRouter>
      <LiksErrorBoundary variant="full">
        <QueryProvider>
          <AuthProvider>
            <UserConfigProvider>
              <I18nProvider>
                <ToastProvider>
                  <LiveEventsProvider>
                    <ChatSessionsProvider>
                      <ChatMessagesProvider>
                        <AppRoutes />
                      </ChatMessagesProvider>
                    </ChatSessionsProvider>
                  </LiveEventsProvider>
                </ToastProvider>
              </I18nProvider>
            </UserConfigProvider>
          </AuthProvider>
        </QueryProvider>
      </LiksErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
